import React, { useEffect, useState } from "react";
import ProcesoLineaBaseService from "../../../services/LineaBase/ProcesoLineaBaseService";
import { IListarProcesosLaPoderosa } from "../../../Interfaces/LineaBase/IProcesos";


export const useListarProcesosLaPoderosa = () => {
  const [dataProceso, setDataProcesos] = useState<IListarProcesosLaPoderosa[]>(
    []
  );
  const [filter, setFilter] = useState({ search: "" });

  const postListarProcesos = () => {
    ProcesoLineaBaseService.postListarProcesosLineaBaseLaPoderosa(filter).then(
      (res) => {
        if (res.status === 200) {
          setDataProcesos(res.data);
        }
      }
    );
  };

  useEffect(() => {
    postListarProcesos();
  }, []);

  return { dataProceso };
};
